import React, { useCallback } from 'react'
import { FormattedHTMLMessage, Modal } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import Content from './Content'
import { lang } from './lang'
import { CardsViews } from '~pages/CardsPage/types'

interface Props {
    isOpen: boolean
    onClose: () => void
    setSelectedId: (id: string) => void
    selectedCard?: GetCard
    setView: (newView: CardsViews) => void
}

function CardsListModal({ isOpen, onClose, setSelectedId, selectedCard, setView }: Props) {
    const setSelectedCardCb = useCallback(
        (card: GetCard) => {
            setSelectedId(card?.id)
            onClose()
        },
        [onClose, setSelectedId]
    )
    const onAddNew = useCallback(() => {
        setView(CardsViews.NewCards)
        onClose()
    }, [onClose, setView])

    return (
        <Modal
            onClose={onClose}
            isOpen={isOpen}
            title={<FormattedHTMLMessage {...lang.title} />}
            dataPointer="cards_list_modal"
            withContentPaddings={false}
        >
            <Content setSelectedCard={setSelectedCardCb} selectedCard={selectedCard} onAddNew={onAddNew} />
        </Modal>
    )
}

export default CardsListModal
